// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2w2KG","footer":"styles_footer__1KDeb"};